import { render, staticRenderFns } from "./BtnSelecionarItemRequisicaoRateio.vue?vue&type=template&id=6946ce8c"
import script from "./BtnSelecionarItemRequisicaoRateio.vue?vue&type=script&lang=js"
export * from "./BtnSelecionarItemRequisicaoRateio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports